import { useMediaQuery } from '@mui/material';
import { ghostButtonSx, secondaryButtonSx } from 'theme/buttons';

export const useOutlinedOnTouch = () => {
  const isTouch = useMediaQuery('(hover: none)');
  return isTouch
    ? ({ variant: 'outlined', sx: secondaryButtonSx } as const)
    : ({ variant: 'text', sx: ghostButtonSx } as const);
};
